/**
 * Route path constants.
 *
 * Centralizes all route definitions to ensure consistency across navigation
 * links and router configuration. Changing a route path here automatically
 * updates all references throughout the application.
 */

export const ROUTES = {
  WELCOME: '/',
  AUTH: '/auth',
  AUTH_CALLBACK: '/auth/callback',
  LOGIN: '/login',
  SIGNUP: '/signup',
  HOME: '/home',
  PROFILE: '/profile',
  PUBLIC_PROFILE: '/profile/:username',
  SETTINGS: '/settings',
  WALLET: '/wallet',
  SUBSCRIPTIONS: '/subscriptions',
  SUPPORT: '/support',
  REPORTS: '/reports',
  DASHBOARD: '/dashboard',
  GO_LIVE: '/go-live',
  UPLOAD: '/upload',
  DOWNLOAD: '/download',
  ADMIN: '/admin',
  ADMIN_REVENUE: '/admin/revenue',
  ADMIN_USERS: '/admin/users',
  ADMIN_MODERATION: '/admin/moderation',
  ADMIN_SUPPORT: '/admin/support',
  ADMIN_STREAMS: '/admin/streams',
  ADMIN_PAYOUTS: '/admin/payouts',
  ADMIN_REPORTS: '/admin/reports',
  ADMIN_SETTINGS: '/admin/settings',
  MESSAGES: '/messages',
  COMMUNITY: '/community',
  COMMUNITY_USER: '/community/user/:ownerUsername',
  DOWNLOAD: '/download',
  WATCH: '/watch/:username',
  VIEWER_CAM_OVERLAY: '/overlay/viewer-cams',
  FORGOT_PASSWORD: '/forgot-password',
  TERMS: '/terms',
  PRIVACY: '/privacy',
  GUIDELINES: '/guidelines',
  CONTACT: '/contact',
};
